// extracted by mini-css-extract-plugin
export var scrollArea = "_pv-0";